/*
sohel 10/06/2022 2701326866  Record Format ->Map Variables ->Search Table Payload Changes, Catagory Lookup and Fixed GAL- 406.
saikrishna 11/03/2022 2701326866 changed the paginationOptions

*/
import {Grid, TablePagination} from '@material-ui/core';
// import MaterialTable from "material-table";
import React, {createRef, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tableIcons} from '../../../../../components/TableIcons';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {fetchFieldListData} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {httpPaginationPost} from '../../../../../util/Rest';

const FieldListSearchTable = ({
  searchData,
  setFieldListId,
  setSelectionChange,
  setSelectionState,
  fieldListId,
  fieldListCode,
  setFieldListCode,
  submit,
  setSubmit,
  fieldType,
}) => {
  const tableRef = createRef();
  const columns = [
    {
      title: 'Field List Code',
      field: 'fieldListCode',
    },
    {
      title: 'Field List Description',
      field: 'fieldListDesc',
    },
    {
      title: 'Base Category',
      field: 'baseCategory',
    },
    {
      title: 'Other Categories',
      field: 'otherCategories',
    },
  ];
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  useEffect(() => {
    setFieldListCode(null);
    if (tableRef?.current && submit) {
      setSelectionChange(false);
      setSelectionState(true);
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [searchData, submit]);

  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `globalfield/search/all/fieldlist`;
                const bodyObj = {
                  baseCategory: searchData?.baseCategory?.categoryCode ? searchData?.baseCategory?.categoryCode : '',
                  fieldListCode: searchData?.fieldListCode ? searchData.fieldListCode : '',
                  fieldListDesc: searchData?.fieldListDescription ?
                    searchData.fieldListDescription :
                    '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  page: submit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  search: '',
                };

                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response?.data?.response?.resultObject;
                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(response.data.response.resultObject.length === 1);
                      setSubmit(false);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            onRowClick={(event, rowData) => {
              setFieldListCode(rowData?.fieldListCode);
              dispatch(fetchFieldListData(rowData.fieldListCode));
            }}
          />
        </div>
      </Grid>
    </>
  );
};

export default FieldListSearchTable;
